

































































































































import { Vue, Component, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { DateTime } from 'luxon'
import moment from 'moment'
import ReservaSalaStore from '@/components/ReservaSala/Store/ReservaSalaStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import { onlyNumber, humanTime, minutesToHours, getWeekdayByDate, getSnackbarMessage } from '@/utils/common'
import { CancelarSolicitacaoParam, TipoOrigemEnum } from '@/types/_'
import { ITriagem, Triagem } from '@/types/implements/Triagem'
import EventBus from '@/plugins/EventBus'
import { adicionarDiasUteisComFeriados } from '@/utils/calcularData'
import { buildSurgerySchedulingLimitParams, getInvalidSchedulingDates, isInvalidSchedulingDate } from '@/services/surgery-scheduling-limit.service'

@Component

export default class ComponentBackofficeConfirmarTriagem extends Vue {
  $refs!: {
    confirmarTriagemRule: any,
    dateA: any,
    surgeryDatePicker: any,
  }

  loader: boolean = false
  loaderNumeroReserva: boolean = false
  numeroReservaMessage: string = ''
  triagem: ITriagem = new Triagem()
  invalidSchedulingDates: { data: string }[] = []

  confirmarTriagemRule: any = {
    valid: false,
    dataCirurgia: [
      v => !!v || 'O campo data da cirurgia é obrigatório.',
    ],
    tempoCirurgia: [
      v => !!v || 'O campo tempo da cirurgia é obrigatório.',
    ],
    dataVirtual: [
      v => (v !== undefined && v !== null) || 'O campo data virtual é obrigatório.',
    ],
  }

  get surgeryDate() {
    const value = this.getBackofficeGlobalStore.solicitacao.dataAgendamento

    if (!value) return null

    const formats = [
      'YYYY-MM-DDTHH:mm:ss.SSSZ',
      'YYYY-MM-DDTHH:mm:ss',
      'YYYY-MM-DDTHH:mm',
      moment.ISO_8601,
    ]

    const parsed = moment(value, formats, true)

    return parsed.isValid() ? parsed.toDate() : null
  }

  set surgeryDate(newDate) {
    if (!newDate) {
      this.getBackofficeGlobalStore.solicitacao.dataAgendamento = ''
      return
    }

    const parsed = moment(newDate)

    this.getBackofficeGlobalStore.solicitacao.dataAgendamento = parsed.isValid()
      ? parsed.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
      : ''
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get surgeryDateInputProps() {
    return {
      textInput: this.textFieldInputProps,
      datePickerInput: this.datePickerInputProps,
      timePickerInput: this.timePickerInputProps,
    }
  }

  get textFieldInputProps() {
    return {
      hint: this.surgeryWeekday,
      persistentHint: true,
      rules: this.confirmarTriagemRule.dataCirurgia,
      readonly: true,
      appendIcon: 'event',
    }
  }

  get datePickerInputProps() {
    const invalidSchedulingDates = this.invalidSchedulingDates.reduce((dateMap, item) => {
      dateMap[item.data] = true
      return dateMap
    }, {})

    const todayDate = new Date(Date.now())
    todayDate.setMonth(todayDate.getMonth() - 3)

    return {
      min: todayDate.toISOString(),
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
      'data-cy': 'data-cirurgia-date',
      allowedDates: date => !invalidSchedulingDates[date],
    }
  }

  get timePickerInputProps() {
    return {
      format: '24hr',
      color: 'rgb(38, 82, 163)',
      min: '00:00',
      'data-cy': 'data-cirurgia-time',
      allowedMinutes: m => m % 15 === 0,
    }
  }

  async onOpen() {
    await this.refreshInvalidSchedulingDates()
  }

  onSurgeryDateChange() {

  }

  clearSurgeryDateInput(parent?) {
    this.surgeryDate = null

    if (parent && parent.clearHandler) {
      parent.clearHandler()
      return
    }

    if (this.$refs.surgeryDatePicker && this.$refs.surgeryDatePicker.clearHandler) {
      this.$refs.surgeryDatePicker.clearHandler()
    }
  }

  async showModalCancelamento() {
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      modal: '',
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoTriagem(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId })
  }

  formatISOToDate(value: string | Date) {
    if (value === '') return value
    return DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_MED)
  }

  eventRender(info) {
    if (info.event.extendedProps.dataAgendamentoVirtual) {
      const span = document.createElement('span')
      span.setAttribute('class', 'fa fa-building white--text ml-2')
      info.el.appendChild(span)
    }
  }

  get getReservaSalaStore() {
    return getModule(ReservaSalaStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getReservaSalasResources() {
    return this.getReservaSalaStore.reservaSalasResource || []
  }

  get getReservaSalasEvents() {
    return this.getReservaSalaStore.reservaSalasEvent
  }

  get loading() {
    return this.loader
  }

  set loading(value: boolean) {
    this.loader = value
  }

  get loadingNumeroReserva() {
    return this.loaderNumeroReserva
  }

  set loadingNumeroReserva(value: boolean) {
    this.loaderNumeroReserva = value
  }

  get doctorDeadlineJustification() {
    const { justificativaDePrazo: doctorDeadlineJustification } = this.getBackofficeGlobalStore.solicitacao

    return doctorDeadlineJustification
  }

  get surgeryWeekday() {
    return this.surgeryDate ? getWeekdayByDate(this.surgeryDate) : ''
  }

  get surgerySuggestedDate() {
    const { healthInsuranceData } = this.getBackofficeGlobalStore
    const sundayIndexWeekDay = 0
    let surgerySuggestedDateObject
    let surgerySuggestedDate

    const {
      prazoEmDiasParaSolicitarCirurgiaComOpme: suggestedSurgeryDateDaysWithOPME,
      prazoEmDiasParaSolicitarCirurgiaSemOpme: suggestedSurgeryDateDaysWithoutOPME,
    } = healthInsuranceData

    if (suggestedSurgeryDateDaysWithOPME && suggestedSurgeryDateDaysWithoutOPME) {
      if (this.surgeryHasOPME) {
        surgerySuggestedDateObject = moment().add(suggestedSurgeryDateDaysWithOPME, 'days')
      } else {
        surgerySuggestedDateObject = moment().add(suggestedSurgeryDateDaysWithoutOPME, 'days')
      }

      surgerySuggestedDate = surgerySuggestedDateObject

      if (surgerySuggestedDateObject.day() === sundayIndexWeekDay) {
        surgerySuggestedDate = surgerySuggestedDate.add(1, 'days')
      }


      return surgerySuggestedDate.format('DD/MM/YYYY')
    }

    return null
  }

  get surgeryHasOPME() {
    return this.getBackofficeGlobalStore.solicitacao.temOpme
  }

  getDatasPrevistas() {
    const datas = [
      this.getBackofficeGlobalStore.solicitacao.opcaoDataPrevisto1,
      this.getBackofficeGlobalStore.solicitacao.opcaoDataPrevisto2,
      this.getBackofficeGlobalStore.solicitacao.opcaoDataPrevisto3,
    ]
    return datas.filter(e => !['', null, undefined].includes(e)).map(e => humanTime(e || '')).join(', ')
  }

  get haspitalEnabledSurgeryDateConfiguration() {
    return this.getBackofficeGlobalStore.solicitacao.hospital && this.getBackofficeGlobalStore.solicitacao.hospital.hospitalConfiguraDataSugeridaEmDiasUteis
  }

  get healthInsuranceHasDeadlineDate() {
    const { healthInsuranceData } = this.getBackofficeGlobalStore
    const {
      prazoEmDiasParaSolicitarCirurgiaComOpme: suggestedSurgeryDateDaysWithOPME,
      prazoEmDiasParaSolicitarCirurgiaSemOpme: suggestedSurgeryDateDaysWithoutOPME,
    } = healthInsuranceData

    return (suggestedSurgeryDateDaysWithOPME && suggestedSurgeryDateDaysWithOPME > 0)
      || (suggestedSurgeryDateDaysWithoutOPME && suggestedSurgeryDateDaysWithoutOPME > 0)
  }

  get surgeryDateWorkingDaysBased() {
    const { healthInsuranceData } = this.getBackofficeGlobalStore
    const {
      prazoEmDiasParaSolicitarCirurgiaComOpme: suggestedSurgeryDateDaysWithOPME,
      prazoEmDiasParaSolicitarCirurgiaSemOpme: suggestedSurgeryDateDaysWithoutOPME,
    } = healthInsuranceData

    const dataEnvio = this.getBackofficeGlobalStore.solicitacao.dataEnvio
      ? new Date(String(this.getBackofficeGlobalStore.solicitacao.dataEnvio))
      : new Date()

    if (this.surgeryHasOPME && suggestedSurgeryDateDaysWithOPME && suggestedSurgeryDateDaysWithOPME > 0) {
      return new Intl.DateTimeFormat('pt-BR').format(adicionarDiasUteisComFeriados(suggestedSurgeryDateDaysWithOPME, dataEnvio))
    }

    if (!this.surgeryHasOPME && suggestedSurgeryDateDaysWithoutOPME && suggestedSurgeryDateDaysWithoutOPME > 0) {
      return new Intl.DateTimeFormat('pt-BR').format(adicionarDiasUteisComFeriados(suggestedSurgeryDateDaysWithoutOPME, dataEnvio))
    }

    return ' - '
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  minutesToHoursUtil(value) {
    return minutesToHours(value)
  }

  async refreshInvalidSchedulingDates() {
    const params = buildSurgerySchedulingLimitParams({
      shouldCheck: !!this.getBackofficeGlobalStore.solicitacao.acoes.verificaLimitadorDeCirurgia,
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      complexity: this.getBackofficeGlobalStore.solicitacao.complexidade,
    })

    if (params) {
      this.invalidSchedulingDates = await getInvalidSchedulingDates(params)

      if (isInvalidSchedulingDate(this.invalidSchedulingDates, this.surgeryDate)) {
        EventBus.$emit('setSnackbar', getSnackbarMessage('A data selecionada não é válida para o agendamento dessa cirurgia. Por favor, escolha outra data.', 'error'))

        this.$nextTick(() => {
          this.clearSurgeryDateInput()
        })
      }
    }
  }

  async checkNumeroReserva() {
    const numeroReserva: string = this.getBackofficeGlobalStore.solicitacao.numeroAgendamento
    this.loadingNumeroReserva = true
    if (numeroReserva) {
      const params: any = {
        solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
        numeroReserva,
        hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      }

      const response = await this.triagem.getCheckNumeroReserva(params)
      this.loadingNumeroReserva = false

      if (!response.success) {
        this.numeroReservaMessage = ''
        EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro na validação no número de reserva.', icon: 'warning', color: '#C62828' })
        return false
      }

      if (response.success && response.data) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Número de reserva duplicado.', icon: 'warning', color: '#C62828' })
        this.numeroReservaMessage = 'Número de reserva duplicado.'
        return false
      }

      this.numeroReservaMessage = ''
      return true
    }

    this.numeroReservaMessage = 'O campo número de reserva é obrigatório.'
    this.loadingNumeroReserva = false
    return false
  }

  modalReset() {
    this.$refs.confirmarTriagemRule.reset()
    this.loading = false
  }

  windowWidth: number = 0
  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  @Emit('setStep')
  backStep(step) { }

  @Emit('confirmarTriagem')
  confirmarTriagem() { }
}
